import styled from '@emotion/styled/macro';

// eslint-disable-next-line import/prefer-default-export
export const Hr = styled.hr`
    margin: ${props => props.theme.spacing.medium} 0;
    color: ${props => props.theme.colours.modalGrey};
    border: 0;
    border-top: 1px solid #dddddd;
`;
